import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withComponentId } from './../../../../common/ComponentIdContext';
import './index.scss';
import BuySellButton from './../../../common/group-button';
import { REDUCER_NAME } from './../../reducer';

class groupButton extends React.Component {
  render() {
    const { currentSearch } = this.props;
    return <BuySellButton code={currentSearch.displayCode} />;
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    currentSearch:
      state[REDUCER_NAME].listMultiCondition[componentId].condition,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(groupButton);
